<script>
import { mapActions } from 'vuex';

import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Drugs'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Drugs'
        };
    },

    computed: {
        labels() {
            return [
                {
                    text: 'Language',
                    value: 'language.code',
                    type: 'enum',
                    isLanguage: true,
                    enumOptions: [
                        { value: 'he', label: 'Hebrew' },
                        { value: 'en', label: 'English' },
                        { value: 'ar', label: 'Arabic' },
                        { value: 'ru', label: 'Russian' }
                    ]
                },
                { value: 'name', width: '150px' },
                {
                    value: 'slug',
                    width: '150px'
                },
                {
                    text: 'Article',
                    value: 'article.name',
                    filterFieldName: 'article.name',
                    width: '150px'
                },
                {
                    text: 'Created by',
                    value: 'createdBy.fullName',
                    width: '150px'
                },
                {
                    text: 'Edited by',
                    value: 'editedBy.fullName',
                    width: '150px'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                },
                {
                    value: 'updatedAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'medicationCategories/index',
            deleteItem: 'medicationCategories/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/medication-categories/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/medication-categories/add');
        }
    }
};
</script>
